<template>
    <div>
        <h6 class="heading-small text-muted mb-4">Signature</h6>

        <template v-if="!!order.signature_data">
            <b-row>
                <img :src="order.signature_data" />
            </b-row>
            <hr />
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>Signee:</strong>
                </b-col>
                <b-col>{{ order.signee }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>Signed At:</strong>
                </b-col>
                <b-col>{{ order.signature_address }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>Completed:</strong>
                </b-col>
                <b-col>{{ order.completed_at }}</b-col>
            </b-row>
        </template>
        <div
            v-else-if="order.signature === 0"
            style="padding: 5em 0; text-align: center"
        >
            Client Signature Not Required
        </div>
        <div v-else style="padding: 5em 0; text-align: center">
            No Signature Data
        </div>
    </div>
</template>

<script>
export default {
    name: 'signature',
    props: {
        order: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    methods: {},
    mounted() {},
    computed: {
        imagedata() {
            if (this.order) {
                return 'data:image/png;base64,' + this.order.signature_data
            } else {
                return null
            }
        },
    },
    watch: {
        order() {
            //console.log(this.order.signature_data)
        },
    },
}
</script>

<style lang="scss" scoped>
</style>